import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Eyebrow } from "./Eyebrow";

export type SectionHeadingProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  align?: "left" | "center";
  className?: string;
  /** Extra classes merged onto the heading element only (e.g. a heading-font override). */
  titleClassName?: string;
  /** Heading element. Defaults to h2; use "h1" for a page's sole title. */
  as?: "h1" | "h2";
};

export function SectionHeading({
  eyebrow,
  title,
  body,
  align = "left",
  className,
  titleClassName,
  as: Heading = "h2",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={clsx(isCenter ? "text-center" : "text-left", className)}>
      {eyebrow ? <Eyebrow pill>{eyebrow}</Eyebrow> : null}
      <Heading
        className={clsx(
          eyebrow ? "mt-5" : "",
          "text-3xl sm:text-4xl font-semibold tracking-tight text-text",
          titleClassName,
        )}
      >
        {title}
      </Heading>
      {body ? (
        <p className={clsx("mt-3 text-base sm:text-lg leading-relaxed text-text-muted", isCenter && "mx-auto max-w-2xl")}>
          {body}
        </p>
      ) : null}
    </div>
  );
}
